(function () {
	angular
		.module('trackeye')
		.controller('NotificationController', NotificationController);

	NotificationController.$inject = ["$timeout", "NotificationService"];

	function NotificationController($timeout, NotificationService) {
		var vm = this;
		vm.notifications = [];

		NotificationService.on('notice', function (data) {
			vm.notifications.unshift({
				message: data.message,
				translate_values: data.translate_values,
				type: data.type
			});

			$timeout(function () {
				vm.notifications.pop();
			}, data.hangtime || 6300);
		});
	}
}());